<template>
  <div v-if="page.home" class="project" :class="{ 'expanded': isCurrentProject(project.$id) && popupOpened }">
    <div class="project__content" @click="expandElement(project.$id, $event)">
      <div class="project__logo">
        <img class="project__logo-img project__logo-img_color" :src="project.text.item.logo.$src" v-if="project.text.item.logo" alt=""/>
        <img class="project__logo-img project__logo-img_white" :src="project.text.item.logo_bw.$src" v-if="project.text.item.logo_bw" alt=""/>
      </div>
      <div class="project__info">
        <div class="project__line project__title">{{project.text.item.company_name}}</div>
        <div class="project__line project__industry" v-html="project.text.item.text_industry"></div>
        <div class="project__line project__exited" v-if="project.$exited" v-html="page.home.project_status"/>
      </div>
      <div class="project__hidden light-bg" @click.stop>
        <span class="project__close" @click.stop="resetProject">
          <span class="icon-exit"></span>
        </span>
        <div class="project__top">
          <div class="project__logo">
            <img :src="project.text.item.logo.$src" v-if="project.text.item.logo" alt=""/>
          </div>
          <div class="project__info">
            <div class="project__line project__title">{{project.text.item.company_name}}</div>
            <div class="project__line project__date">{{project.$project_year}}</div>
            <div class="project__line project__industry" v-html="project.text.item.text_industry"></div>
            <div class="project__line project__exited" v-if="project.$exited" v-html="page.home.project_status"/>
          </div>
        </div>
        <div class="project__text">
          <div v-html="project.text.item.text_content"></div>
          <div v-if="project.$site_link">
            <a :href="project.$site_link" @click.stop>{{ project.$site_link.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, '') }}</a>
          </div>
        </div>
        <div v-if="project.photo" class="project__photo">
          <img :src="project.photo.large.$src" alt=""/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'projects',
    computed: mapGetters({
      page: 'page',
      projects: 'projects',
      popupOpened: 'popupOpened',
      currentProject: 'currentProject',
    }),
    data() {
      return {
        isExpanded: false,
      };
    },
    props: ['project'],
    methods: {
      isCurrentProject(id) {
        return id === this.currentProject;
      },
      expandElement(id, event) {
        const currentElem = event.currentTarget;
        if (!this.popupOpened) {
          this.$store.commit('SET_POPUP_STATE', true);
        }
        setTimeout(() => {
          this.$SmoothScroll(currentElem, 500);
        }, 150);
        this.$store.commit('SET_CURRENT_PROJECT', id);
      },
      resetProject() {
        this.$store.commit('SET_CURRENT_PROJECT', '');
        this.$store.commit('SET_POPUP_STATE', false);
      },
    },
    mounted() {
      window.addEventListener('keyup', (event) => {
        if (event.keyCode === 27 && this.currentProject !== '') {
          this.resetProject();
        }
      });
    },
  };
</script>

<style>
  .project {
    cursor: pointer;
    display: inline-block;
    vertical-align: top;
    height: 300px;
    padding: 0 15px 15px 0;
    width: 25%;
    color: #000;
    position: relative;
    z-index: 1;
    
    transition: z-index 0.3s cubic-bezier(0.455, 0.065, 0.000, 0.990);

    &__content {
      position: relative;
      padding: 130px 40px 40px;
      height: 100%;
      width: 100%;
      
      transition: color 0.3s cubic-bezier(0.455, 0.065, 0.000, 0.990);

      &:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: #fff;
        z-index: -1;
        
        transition: all 0.3s cubic-bezier(0.455, 0.065, 0.000, 0.990);
      }

      & > .project__logo {

        .project__logo-img {
          &_color {
            display: inline-block;
          }

          &_white {
            display: none;
          }
        }
      }
    }

    &__logo {
      position: absolute;
      padding: 30px 60px;
      top: 0;
      left: 0;
      right: 0;
      height: 130px;
      text-align: center;

      &:before {
        content: '';
        height: 100%;
        display: inline-block;
        vertical-align: middle;
      }

      img {
        max-width: 96%;
        max-height: 100%;
        display: inline-block;
        vertical-align: middle;
      }
    }

    &__line {
      margin-bottom: 9px;
    }

    &__info {
      text-transform: uppercase;
      font-size: 13px;
      line-height: 150%;
      letter-spacing: 0.5px;
      color: rgba(0, 0, 0, 0.6);
    }

    &__title {
      color: $darkest-color;
      font-family: 'UniversLTStdBold';
    }

    &__exited {
      display: inline-block;
      padding: 4px 5px 0;
      height: 24px;
      color: $lightest-color;
      background-color: $main-color;
      
      transition: all 0.3s cubic-bezier(0.455, 0.065, 0.000, 0.990);
    }

    &__hidden {
      position: absolute;
      cursor: default;
      width: 100%;
      min-height: 100%;
      left: 0;
      top: 0;
      color: #000;
      z-index: 1;
      padding: 40px;
      opacity: 0;
      pointer-events: none;
      
      transition: width 0.5s cubic-bezier(0.455, 0.065, 0.000, 0.990);

      &:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: #fff;
        z-index: -1;
        transform: scale(1.15);
      }
    }

    &__close {
      position: absolute;
      top: 20px;
      right: 0;
      cursor: pointer;
      font-size: 25px;
      display: block;
      cursor: pointer;
      z-index: 1;
      transition: color 0.2s ease;

      &:hover {
        color: $main-color;
      }
    }

    &__top {
      position: relative;
      height: 285px;
      padding: 130px 40px 0;
      margin: -40px -40px 0;

      &:after {
        content: '';
        display: block;
        clear: both;
      }

      .project {
        &__logo {
          right: 40%;
          height: 100%;
          padding: 30px 60px;
        }

        &__info {
          width: 35%;
          float: right;
        }
      }
    }

    &__text {
      overflow: hidden;
      width: 100%;
      max-height: 0;
      transition: max-height 0.5s cubic-bezier(0.455, 0.065, 0.000, 0.990);

      a {
        color: $darkest-color;
        border-color: $main-color;
      }
    }

    &__photo {
      margin: 20px 0 0;
      position: absolute;
      width: 115%;
      left: -15%;
      opacity: 0;
      transition: all 0.6s cubic-bezier(0.455, 0.065, 0.000, 0.990) 0.1s;

      img {
        max-width: 100%;
        display: block;
      }
    }

    &:first-child,
    &:last-child,
    &:nth-child(9) {
      width: 50%;

      .project {
        &__logo {
          right: 40%;
          height: 100%;
        }

        &__info {
          width: 35%;
          float: right;
        }

        &__hidden{
          width: 100%;
          left: 0 !important;
        }
      }
    }

    &:nth-child(7n),
    &:nth-child(7n-4) {
      .project {
        &__hidden {
          left: auto;
          right: 0;
        }
      }
    }

    &:hover {
      z-index: 2;

      .project {

        &__content {
          color: $lightest-color;

          &:after {
            background: $main-color;
            transform: scale(1.15);
          }

          & > .project__logo {
            .project__logo-img {
              &_color {
                display: none;
              }

              &_white {
                display: inline-block;
              }
            }
          }
        }

        &__info {
          color: $lightest-color;
        }

        &__title {
          color: $lightest-color;
        }

        &__exited {
          color: $main-color;
          background-color: $lightest-color;
        }
      }
    }

    &.expanded {
      position: relative;
      z-index: 11;

      &:hover {
        .project {
          &__content {
            &:after {
              background: #fff;
            }
          }

          &__exited {
            display: inline-block;
            padding: 4px 5px 0;
            height: 24px;
            color: $lightest-color;
            background-color: $main-color;
          }

          &__info {
            color: rgba(0, 0, 0, 0.6);
          }

          &__title {
            color: $darkest-color;
          }
        }
      }

      .project {
        &__text {
          height: auto;
          max-height: 500px;
        }

        &__hidden {
          opacity: 1;
          pointer-events: auto;
          width: 200%;
        }

        &__content {
          &:after {
            background: #fff;
          }
        }

        &__photo {
          left: -10%;
          opacity: 1;
        }
      }

      &:first-child,
      &:last-child,
      &:nth-child(9) {
        width: 50%;

        .project {
          &__hidden{
            width: 100%;
          }
        }
      }
    }
  }

  @media (max-width: 1150px) {
    .project {
      width: 50%;

      &__logo {
        right: 40%;
        height: 100%;

        img{
          position: absolute;
          max-height: 80%;
          max-width: 100%;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);

          .app-ie & {
            max-height: 80%;
            max-width: 80%;
          }
        }
      }

      &__info {
        width: 35%;
        float: right;
      }

      &__hidden{
        width: 100%;
        left: 0 !important;
      }

      &.expanded {
        .project {
          &__hidden {
            width: 100% !important;
          }
        }
      }
    }
  }

  @media (max-width: 850px) {
    .project {
      display: block;
      height: auto;
      min-height: 100px;
      padding: 0;
      width: 100% !important;
      background: #eee;
      border-bottom: 1px solid rgba(150, 150, 150, 0.3);

      &__close {
        top: 15px;
        right: 15px;
      }

      &__content {
        padding: 25px;

        &:after {
          display: none;
        }
      }

      &__logo {
        right: auto !important;
        height: auto !important;
        left: 0;
        bottom: 0;
        width: 30%;
        height: 100px !important;
        padding: 15px 0 15px 25px;

        img {
          position: static;
          transform: none;
        }

        .project__logo-img {
          &_color {
            display: inline-block;
          }

          &_white {
            display: none;
          }
        }

        img {
          height: auto;
          max-width: 100%;
        }
      }

      &__info {
        padding-left: 35%;
        width: 100% !important;
        float: none !important;
      }

      &__text {
        margin-top: 20px;
      }

      &__hidden {
        width: auto !important;
        padding: 25px;
        margin: -25px;
        position: relative;
        width: auto;
        display: none;

        &:after {
          transform: none;
        }
      }

      &__top {
        padding: 25px;
        margin: -25px;
        height: auto;

        .project {
          &__logo {
            padding: 15px 0 15px 25px;
          }
        }
      }

      &__photo {
        position: relative;
        left: 0;
        margin-bottom: -25px;
        margin-left: -25px;
        margin-right: -25px;
      }

      &:first-child,
      &:last-child {
        width: 100%;
      }

      &:hover {
        .project {
          &__content {
            color: #000;

            &:after {
              display: none;
            }

            & > .project__logo {
              .project__logo-img {
                &_color {
                  display: inline-block;
                }

                &_white {
                  display: none;
                }
              }
            }
          }

          &__info {
            color: rgba(0, 0, 0, 0.6);
          }

          &__title {
            color: $darkest-color;
          }

          &__exited {
            color: $lightest-color;
            background-color: $main-color;
          }
        }
      }

      &.expanded {
        .project {
          &__content {
            & > .project__logo,
            & > .project__info {
              display: none;
            }
          }

          &__hidden {
            display: block;
            width: auto !important;

            .project__logo img {
              /*margin-top: -29px;*/
            }
          }

          &__text {
            height: auto;
          }

          &__photo {
            left: 0;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Project.vue?b1683164